export default __webpack_public_path__ + "static/media/Deathgasp Mitts.4935f719.jpg";